
import { SalesMetricsBasic } from "@/pages/admin/sales";
import { createMetricsConfig } from "./config/metricsConfig";
import { MetricItem } from "./MetricItem";

interface SalesMetricsGridProps {
  salesMetrics: SalesMetricsBasic | undefined;
  isLoading: boolean;
  onDailyClick: () => void;
  onWeeklyClick: () => void;
  onMonthlyClick: () => void;
  onYearlyClick: () => void;
}

export const SalesMetricsGrid = ({
  salesMetrics,
  isLoading,
  onDailyClick,
  onWeeklyClick,
  onMonthlyClick,
  onYearlyClick,
}: SalesMetricsGridProps) => {
  console.log('SalesMetricsGrid rendering:', { salesMetrics, isLoading }); // Keep logging

  // Log total premium values to verify correct calculation
  if (salesMetrics) {
    console.log('Total premium values:', {
      daily: salesMetrics.daily,
      weekly: salesMetrics.weekly,
      monthly: salesMetrics.monthly,
      yearly: salesMetrics.yearly,
      endorsementPremium: salesMetrics.endorsementPremium,
      dailyTotal: salesMetrics.dailyTotal,
      weeklyTotal: salesMetrics.weeklyTotal,
      monthlyTotal: salesMetrics.monthlyTotal,
      yearlyTotal: salesMetrics.yearlyTotal
    });
  }

  const metrics = createMetricsConfig(salesMetrics, {
    onDailyClick,
    onWeeklyClick,
    onMonthlyClick,
    onYearlyClick,
  });

  // Add policies to each metric
  const metricsWithPolicies = metrics.map(metric => {
    if (metric.title === 'Daily Sales') {
      // For daily sales, we need to combine daily policies with daily endorsements
      // Here we're simply passing the daily policies which should already include those with endorsements
      return { ...metric, policies: salesMetrics?.dailyPolicies || [] };
    } else if (metric.title === 'Weekly Sales') {
      return { ...metric, policies: salesMetrics?.weeklyPolicies || [] };
    } else if (metric.title === 'Monthly Sales') {
      return { ...metric, policies: salesMetrics?.monthlyPolicies || [] };
    } else if (metric.title === 'Year to Date') {
      return { ...metric, policies: salesMetrics?.yearlyPolicies || [] };
    }
    return metric;
  });

  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 3xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
      {metricsWithPolicies.map((metric) => (
        <MetricItem
          key={metric.title}
          metric={metric}
          value={metric.getValue(salesMetrics)}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};
